export default "__VITE_ASSET__LCR_a93L__"